import { z } from 'zod';
import { claimSchema } from './claim';
import { remittanceLineSchema } from './remittanceLine';

export const remittanceSchema = z.object({
  id: z.string(),
  filename: z.string(),
  siteID: z.string(),
  createdAt: z.string(),
  totalFeeAssessed: z.string().or(z.number()),
  parsedAt: z.string(),
  claims: z.lazy(() => claimSchema.array().optional().or(z.string())),
  remittanceLines: z.lazy(() => remittanceLineSchema.array().optional()),
});
